import * as yup from '@if/core/yup';
const createEditSinAndLoanAmountBaseSchema = (minLoanAmount, maxLoanAmount) => {
    return {
        id: yup.string().default(''),
        needsApplicantSin: yup.bool(),
        needsCoapplicantSin: yup.bool(),
        applicantSin: yup
            .string()
            .nullable()
            .when('needsApplicantSin', {
            is: true,
            then: (schema) => schema.required().validSIN(),
        }),
        requestedLoanAmount: yup.double().required().default(0).min(minLoanAmount).max(maxLoanAmount),
    };
};
export const createEditSinAndLoanAmountSchema = (minLoanAmount, maxLoanAmount) => {
    return yup.object(createEditSinAndLoanAmountBaseSchema(minLoanAmount, maxLoanAmount));
};
export const createEditSinAndLoanAmountWithCoapplicantSchema = (minLoanAmount, maxLoanAmount) => {
    return yup.object({
        ...createEditSinAndLoanAmountBaseSchema(minLoanAmount, maxLoanAmount),
        needsCoapplicantSin: yup.bool().default(false),
        coapplicantSin: yup
            .string()
            .nullable()
            .when('needsCoapplicantSin', {
            is: true,
            then: (schema) => schema.required().validSIN(),
            otherwise: (schema) => schema.notRequired(),
        }),
    });
};
